const getRawApiBaseUrl = () => {
  const value = process.env.REACT_APP_BACKEND_URL;
  return typeof value === 'string' ? value.trim() : '';
};

export const resolveApiBaseUrl = () => {
  const baseUrl = getRawApiBaseUrl().replace(/\/+$/, '');

  if (!baseUrl) {
    throw new Error('REACT_APP_BACKEND_URL is required');
  }

  return baseUrl;
};
